"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var React=require("react"),a=require("styled-components"),fonts=require("../fonts.js");function _interopDefaultLegacy(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var React__default=_interopDefaultLegacy(React);let l=a.createGlobalStyle`
  @font-face {
    font-family: "CircularXXWeb-Bold";
    src: url(${fonts.CircularXXWebBold}) format("woff");
  }

  @font-face {
    font-family: "CircularXXWeb-Book";
    src: url(${fonts.CircularXXWebBook}) format("woff");
  }

  @font-face {
    font-family: "CircularXXWeb-Medium";
    src: url(${fonts.CircularXXWebMedium}) format("woff");
  }

  html,
  body {
    height: 100%;
    width: 100%;
  }

  body {
    font-family: ${({theme:e})=>e.typography.fontFamily};
  }

  body.fontLoaded {
    font-family: ${({theme:e})=>`'Lato', ${e.typography.fontFamily}`};
  }
`;const GlobalStyle=({...e})=>React__default.default.createElement(l,e);exports.GlobalStyle=GlobalStyle;
//# sourceMappingURL=GlobalStyle.js.map
